/* 
    查询区参照过滤条件Modal
    created by: liyaoh 2021-04-01
*/
import React, { Component } from "react";
import HotKeysModal from "Components/HotKeysModal";
import platform from "Pub/js/platform";
import Ajax from "Pub/js/ajax";
import { langCheck } from "Pub/js/utils";
import initTemplate from "./initTemplate";
import ItemSelect from './itemSelect';
import "./index.less";
const { createPage } = platform;
const { NCButton } = platform.base;
const TABLE_ID = "referFilterTable";

class ReferFilterModal extends Component {
    constructor(props) {
        super(props);
        this.props.use.editTable(TABLE_ID);
        let meta = initTemplate(props);

        //元数据类型的关联字段是下拉框
        // if(!!props.selectCard.metapath){
        this.modifyMeta(meta);
        // }
        // this.props.meta.setMeta(meta);
        // console.log(this.props.meta.getMeta());
        this.state = { buttoDisabled: true };
    }

    componentDidMount() {
        this.props.editTable.setStatus(TABLE_ID, "edit");
        if (this.props.selectCard["refcondition"]) {this.initTableData();}
    }

    initTableData = () => {
        const referFilterItems = this.props.selectCard["refcondition"];
        const tableData = this.formatTableData(referFilterItems);
        this.props.editTable.setTableData(TABLE_ID, { rows: tableData });
    };

    modifyMeta = meta => {
        this.getRefRelyPro().then(({ refRelyVOList }) => {
            const options = refRelyVOList.map((item, index) => ({
                display: `${item.displayName} ${item.name}`,
                value: `${item.columnName}--${index}`,
            }));

            meta[TABLE_ID].items.map(item => {
                if (item.attrcode === 'key') {
                    item.itemtype = 'customer';
                    item.render = (text, record, index) => {
                        const values = record.values || {};
                        const handleSelectChange = val => {
                            this.props.editTable.setValByKeyAndIndex(TABLE_ID, index, "key", { value: val && val.split('--')[0] });
                        };
                        return (
                            <ItemSelect
                                value={values.key.value}
                                optionData={options}
                                onChange={handleSelectChange}
                            />
                        );
                    };
                }
                return item;
            });
            this.props.meta.setMeta(meta);
            this.setState({ buttoDisabled: false });
        });
        return meta;
    }

    //获取参照依赖字段
    getRefRelyPro = () => {
        return new Promise(resolve => {
            const { selectCard } = this.props;
            const { refname, datatype, metadataproperty, dataval = '' } = selectCard;
            Ajax({
                url: "/nccloud/platform/templet/getRefRelyPro.do",
                data: 
                {
                    pk_refinfo: dataval.split(',').shift(), // 参照/档案主键
                    datatype, // 数据类型
                    metadataproperty,
                    refname, // 参照名称
                },
                // {
                //     propertyId: this.props.selectCard.pk_query_property,
                //     areaType: this.props.currentArea.areatype
                // },
                info: {
                    name: langCheck(
                        "ZoneSetting-000017",
                        "pages",
                        this.props.json,
                    ) /* 国际化处理： 单据模板设置*/,
                    action: langCheck(
                        "ZoneSetting-000200",
                        "pages",
                        this.props.json,
                    ) /* 国际化处理： 查询*/,
                },
                success: res => {
                    let { success, data } = res.data;
                    if (success) {
                        resolve(data);
                    }
                },
            });
        });
    }

    //将数据源转换成editTable格式数据
    formatTableData = data => {
        const result = JSON.parse(data);
        return result.map(item => ({ values: this.obj2ObjValue(item) }));
    };

    //{ key: value }转成{ key: { display, value }}格式
    obj2ObjValue = obj => {
        const typeMap = {
            item: langCheck("ZoneSetting-000333", "pages", this.props.json), /* 国际化处理： 字段*/
            constant: langCheck("ZoneSetting-000333", "pages", this.props.json), /* 国际化处理： 字段*/
            code: langCheck("ZoneSetting-000333", "pages", this.props.json), /* 国际化处理： 字段*/
        };
        let result = {};
        for (const [key, val] of Object.entries(obj)) {
            result[key] = {
                display: key === 'type' ? typeMap[val] : '',
                value: val,
            };
        }
        return result;
    };

    //设置模态框隐藏
    handleModalClose = () => {
        this.props.setModalVisibel("referFilterModalVisible", false);
    };

    handleOk = () => {
        const tableData = this.props.editTable.getViewData(TABLE_ID);

        if (tableData.length > 0) {
            let result = tableData.map(item => {
                const { key, value, nofilter } = item.values;
                let nofilterVal = (nofilter && nofilter.value) ? nofilter.value : false;
                return { key: key.value, value: value.value, nofilter: nofilterVal };
            });

            if (this.props.editTable.checkRequired(TABLE_ID, tableData)) {
                this.props.handleSelectChange(JSON.stringify(result), "refcondition");
                this.handleModalClose();
            }
        } else {
            this.props.handleSelectChange('', "refcondition");
            this.handleModalClose();
        }
    };

    //增行
    handleAddRow = () => {
        this.props.editTable.addRow(TABLE_ID, -1, false, {
            // 字段
            type: { display: langCheck("ZoneSetting-000333", "pages", this.props.json), value: "item" },
        });
    };

    //删行
    handleRemoveRow = () => {
        const { getCheckedRows, deleteTableRowsByIndex } = this.props.editTable;
        const checkedRows = getCheckedRows(TABLE_ID);
        const checkedIdxs = checkedRows.map(item => item.index);
        deleteTableRowsByIndex(TABLE_ID, checkedIdxs);
    };

    //编辑后事件
    handleAfterEvent = (
        props,
        moduleId,
        attrcode,
        value,
        changedrows,
        index,
        record,
        type,
        eventName,
    ) => {
        if (attrcode === "type") {
            props.editTable.setValByKeyAndIndex(TABLE_ID, index, "value", {
                display: "",
                value: "",
            });
        }
    };

    renderContent = () => {
        const { json, editTable } = this.props;
        let { createEditTable } = editTable;
        const { buttoDisabled } = this.state;
        return (
            <div className='flex-container' style={{ height: "100%" }}>
                <div className="modal-header">
                    <div className="modal-header-content">
                        <NCButton onClick={this.handleAddRow} disabled={buttoDisabled}>
                            {/* 国际化处理：新增 */}
                            {langCheck("ZoneSetting-000260", "pages", json)}
                        </NCButton>
                        <NCButton onClick={this.handleRemoveRow} disabled={buttoDisabled}>
                            {/* 国际化处理：删除 */}
                            {langCheck("ZoneSetting-000190", "pages", json)}
                        </NCButton>
                    </div>
                </div>
                <div className='modal-table flex-container'>
                    {createEditTable(TABLE_ID, {
                        showCheck: true,
                        hideRightMenu: true,
                        onAfterEvent: this.handleAfterEvent,
                        onBeforeEvent: this.handleBeforeEvent,
                    })}
                </div>
                <div className="modal-footer">
                    <div className="tip-title">
                        <i className="icon iconfont icon-bangzhutishi"></i>
                        {/* 国际化处理：使用说明1 2111新增*/}
                        {langCheck("ZoneSetting-000342", "pages", json)}
                    </div>
                    {/* 国际化处理：使用说明2 2111新增*/}
                    <ul>
                        <li>{langCheck("ZoneSetting-000343", "pages", json)}</li>
                        <li>{langCheck("ZoneSetting-000344", "pages", json)}</li>
                        <li>{langCheck("ZoneSetting-000345", "pages", json)}</li>
                        <li>{langCheck("ZoneSetting-000346", "pages", json)}</li>
                    </ul>
                    {/* 国际化处理：使用说明3 2111新增*/}
                    <div>{langCheck("ZoneSetting-000347", "pages", json)}</div>
                </div>
            </div>
        );
    };
    render() {
        const { modalVisibel, json } = this.props;
        return (
            <HotKeysModal
                maskClosable={true}
                wrapClassName="zonesetting-referfilter-modal"
                title={langCheck("ZoneSetting-000331", "pages", json)} /* 国际化处理： 参照过滤*/
                visible={modalVisibel}
                size="lg"
                onOk={this.handleOk}
                onCancel={this.handleModalClose}
            >
                {this.renderContent()}
            </HotKeysModal>
        );
    }
}
ReferFilterModal = createPage({})(ReferFilterModal);
export default ReferFilterModal;
